export const TAB_LIST_PROFILE = [
  {
    id: 1,
    name: 'Articles',
    value: null
  },
  {
    id: 2,
    name: 'Comments',
    value: 'myComments'
  },
  {
    id: 3,
    name: 'Reactions',
    value: 'myReactions'
  },
  {
    id: 4,
    name: 'Twigs Given',
    value: 'myTwigsGiven'
  },
  {
    id: 5,
    name: 'Reading List',
    value: 'myReading'
  }
];
